import { render, staticRenderFns } from "./WorkContactReadonlyLayout.vue?vue&type=template&id=3a8aec68&scoped=true"
import script from "./WorkContactReadonlyLayout.vue?vue&type=script&lang=js"
export * from "./WorkContactReadonlyLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkContactReadonlyLayout.vue?vue&type=style&index=0&id=3a8aec68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8aec68",
  null
  
)

export default component.exports